/* The tones a client can pick for AI social captions. Ids must match
   worker/social-tone.ts — a test enforces it — because the Worker turns the id
   into prompt guidance and treats anything unknown as house style. */
export interface SocialToneOption { id: string; label: string; description: string }

export const SOCIAL_TONES: SocialToneOption[] = [
  { id: 'house', label: 'House style', description: 'Your saved voice and rules — the default for everything we write for you.' },
  { id: 'humorous', label: 'Humorous', description: 'Light and playful, one genuine wink per caption. Never at the customer\'s expense.' },
  { id: 'catchy', label: 'Catchy', description: 'A scroll-stopping first line, then one clear point. Headline energy, no clickbait.' },
  { id: 'direct', label: 'Direct — explains the project', description: 'Plainly what was done, for whom, and why it matters. Facts, not adjectives.' },
  { id: 'warm', label: 'Warm', description: 'Neighborly and grateful — speaks to the community you serve.' },
  { id: 'professional', label: 'Professional', description: 'Measured and expertise-led. Right for a commercial or B2B audience.' },
  { id: 'storytelling', label: 'Storytelling', description: 'A small arc: the situation, what your team did, how it ended.' },
  { id: 'urgent', label: 'Urgent / timely', description: 'A season, a deadline, or a problem that gets worse if ignored. One clear call to action.' },
];

export const DEFAULT_SOCIAL_TONE = 'house';
